import get from 'lodash/get';
import React from 'react'
import { useTranslation } from 'react-i18next';
import HistoryBlock, { processHistory } from './HistoryBlock';

const HistoryDataConsent = ({device}) => {
  const { t } = useTranslation();

  return (
    <HistoryBlock
      title={t("devices.DataConsentHistory")}
      data={
        processHistory("data_consent")(get(device, 'history.data_consent'))}
      cloumnTitle="GeoData consent"
      cloumnAccessor={"data_consent"}
    />
   );
}

export default HistoryDataConsent;